var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.date)?_c('span',{staticClass:"xl:tw-inline-block badge badge-primary tw-py-1 "},[_vm._v("ÉRKEZIK "+_vm._s(_vm.year)+"."+_vm._s(_vm.getFormatedMonth)+".")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }